import { Ability } from '@casl/ability'
import useJwt from '@/auth/jwt/useJwt'
import { initialAbility } from './config'

//  Read ability from localStorage
// * Handles auto fetching previous abilities if already logged in user
// ? You can update this if you store user abilities to more secure place
// ! Anyone can update localStorage so be careful and please update this
const userData = JSON.parse(localStorage.getItem(useJwt.jwtConfig.storageUserDataKeyName))
const existingAbility = userData ? userData.ability : null

let newAbility = [
  ...initialAbility,
]
if (existingAbility) {
  newAbility = [
    ...existingAbility,
    ...initialAbility,
  ]
}

export default new Ability(newAbility)
